// extracted by mini-css-extract-plugin
export default {"cabinet":"EnregistrementChoixCabinet_cabinet__scRK7","cabinetSelected":"EnregistrementChoixCabinet_cabinetSelected__b+ZP-"};